import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/PageHeader.scss';
import Header from '../containers/Header';

export default function PageHeader({
    children,
    className,
    ...props
}) {
    const classes = classNames(styles.header, className);
    return (
        <div {...props} className={classes}>
            {children || <Header />}
        </div>
    );
}

PageHeader.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
